/**
 * SPDX-FileCopyrightText: 2022 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export const SET_VIEW_WIDTH = 'SET_VIEW_WIDTH'
export const SET_HEADINGS = 'SET_HEADINGS'
export const SET_ATTACHMENT_LIST = 'SET_ATTACHMENT_LIST'
